import React from 'react'
import OfertaFirst from '../components/OfertaFirst/OfertaFirst'
import SectionForm from '../components/SectionForm/SectionForm'
import WelcomeOferta from '../components/WelcomeOferta/WelcomeOferta'

const Oferta = () => {
	return (
		<>
			<WelcomeOferta />
			<OfertaFirst />
			<SectionForm />
		</>
	)
}

export default Oferta
